<template>
  <div>
    <v-tooltip bottom v-if="params.clickable(params)">
      <template v-slot:activator="{ on, attrs }">
        <v-card v-bind="attrs" v-on="on" flat tile class="comments-clickable readonly-column" @click="clickHandler()">
          <v-icon color="var(--v-resRed-darken1)">mdi-flag</v-icon>
        </v-card>
      </template>
      <span>Comments/Flags</span>
    </v-tooltip>
    <v-card else flat tile class="readonly-column">
      <v-icon color="var(--v-resRed-darken1)">mdi-flag</v-icon>
    </v-card>
  </div>
</template>

<script>
  export default {
    name: 'UnresolvedCommentsRowButton',
    methods: {
      clickHandler: function () {
        this.params.onClick(this.params);
      }
    }
  }
</script>

<style scoped lang="scss">
  .comments-clickable {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
</style>
